import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Default error for subAccount
 */
export class SubAccount extends CedeSDKError {
  constructor(code = SdkErrorCodes.SUB_ACCOUNT_ERROR, message = SdkErrorMessages.SUB_ACCOUNT_ERROR) {
    super(code, message);
    this.name = "SubAccountError";
  }
}

/**
 * @description Thrown when the sub account is not found for a given sub account uid
 */
export class SubAccountNotFoundError extends SubAccount {
  constructor(uid: string) {
    super(SdkErrorCodes.SUB_ACCOUNT_NOT_FOUND_ERROR, SdkErrorMessages.SUB_ACCOUNT_NOT_FOUND_ERROR(uid));
    this.name = "SubAccountNotFoundError";
  }
}

/**
 * @description Thrown when the sub account is not enabled for the user
 */
export class SubAccountNotEnabledError extends SubAccount {
  constructor() {
    super(SdkErrorCodes.SUB_ACCOUNT_NOT_ENABLED_ERROR, SdkErrorMessages.SUB_ACCOUNT_NOT_ENABLED_ERROR);
    this.name = "SubAccountNotEnabledError";
  }
}
